module.exports = __webpack_public_path__ + "img/pleisure_bodyimage09.dde69b9a.jpg";